import { render, staticRenderFns } from "./AlertaEntidadesCodBncNulos.vue?vue&type=template&id=75a987a7&"
import script from "./AlertaEntidadesCodBncNulos.vue?vue&type=script&lang=js&"
export * from "./AlertaEntidadesCodBncNulos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VProgressCircular})
